/**
 * 获取友好的时间显示
 * @param {Date|number|string} time
 * > Date: 时间对象
 * > number: 时间戳
 * > string: 格式化的时间字符串，如'2017-10-01 18:00:00'
 * @param {boolean} 是否显示时间，默认false
 * @return {string} 友好的时间显示
 */
export default function (time, withTime = false) {
  let date = time instanceof Date ? time : typeof time === 'number' ? new Date(time) : new Date((time || '').replace(/-/g, '/'))
  let diff = (new Date().getTime() - date.getTime()) / 1000
  let dayDiff = Math.floor(diff / 86400)
  let isValidDate = Object.prototype.toString.call(date) === '[object Date]' && !isNaN(date.getTime())
  if (!isValidDate) {
    console.error('not a valid date')
  }
  const formatDate = function (date, withTime) {
    let today = new Date(date)
    let year = today.getFullYear()
    let month = ('0' + (today.getMonth() + 1)).slice(-2)
    let day = ('0' + today.getDate()).slice(-2)
    let hour = today.getHours()
    let minute = today.getMinutes()
    let second = today.getSeconds()
    return withTime ? `${year}-${month}-${day} ${hour}:${minute}:${second}` : `${year}-${month}-${day}`
  }
  if (isNaN(dayDiff) || dayDiff < 0 || dayDiff >= 30) {
    return formatDate(date, withTime)
  }
  /* eslint no-mixed-operators: 0 */
  return (
    (dayDiff === 0 &&
      ((diff < 60 && '刚刚') ||
        (diff < 120 && '1分钟前') ||
        (diff < 3600 && Math.floor(diff / 60) + '分钟前') ||
        (diff < 7200 && '1小时前') ||
        (diff < 86400 && Math.floor(diff / 3600) + '小时前'))) ||
    (dayDiff === 1 && '昨天') ||
    (dayDiff < 7 && dayDiff + '天前') ||
    (dayDiff < 30 && Math.ceil(dayDiff / 7) + '周前')
  )
}
